import { BorderColor, BorderStyle } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import Popover from "@mui/material/Popover";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { HexColorPicker } from "react-colorful";

export default function ColourField(props) {
	const theme = useTheme();
	let value = props.value;

	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleFocus = (event) => {
		if( !value ){
			handleClick(event);
		}
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	const updateColour = (e) => {
		value = e?.target?.value || e;
		props?.onChange?.(value);
	};

	const adornBoxSx = {
		borderRadius: 1,
		height: 20,
		width: 40,
		backgroundColor: value || '#999999',
		borderColor: theme.palette.action.selected,
		borderWidth: 1,
		borderStyle: 'solid',
		mb: 1
	}

	const endAdornment = <InputAdornment position="end"><Box sx={adornBoxSx} onClick={handleClick} /></InputAdornment>

	return (
		<React.Fragment>
			<TextField label="Colour" variant="standard" value={value || ''} onFocus={handleFocus} onChange={(e) => updateColour(e)} slotProps={{ input: { endAdornment } }} {...props} />
			<Popover open={open} anchorEl={anchorEl} onClose={handleClose} disableRestoreFocus={true} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} transformOrigin={{ vertical: 'top', horizontal: 'center' }}>
				<HexColorPicker style={{ padding: '20px' }} color={value || '#ff0000'} onChange={(e) => updateColour(e)} />
			</Popover>
		</React.Fragment>
	);
}
